export default __webpack_public_path__ + "static/media/work-item3.ec3b0d08.svg";